<router-outlet></router-outlet>

<!-- <ngx-spinner
  bdColor="rgba(0, 0, 0, 0.3)"
  type="">
  <img style="padding-bottom: 200px; width: 200px; height:auto" src="{{LoaderLogoJsonPath}}">  
</ngx-spinner> -->

<ngx-spinner color="white" size="medium" type="ball-running-dots"></ngx-spinner>
